import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../instance';
 

const initialState = {
    deleteloading: false,
   
};
 
export const deletePaybill = createAsyncThunk(
    "staffSettingSlice/deletePaybill",
    async (data) => {
      const res = await axiosInstance
        .delete(`/api/v1/payments/delete-paybill/${data?.pbId}`)
        .then((res) => res.data);
      return res;
    }
  ); 

  export const deleteTariff = createAsyncThunk(
    "staffSettingSlice/deleteTariff",
    async (data) => {
      const res = await axiosInstance
        .delete(`/api/v1/payments/deleteTariff/${data?.tarUid}`)
        .then((res) => res.data);
      return res;
    }
  );

  export const deleteTariffNegotiated = createAsyncThunk(
    "staffSettingSlice/deleteTariffNegotiated",
    async (data) => {
      const res = await axiosInstance
        .delete(`/api/v1/payments/tariff-negotiated/deleteNegotiatedTariff/${data?.tarUid}`)
        .then((res) => res.data);
      return res;
    }
  );

  export const deleteGroupMember = createAsyncThunk(
    "staffSettingSlice/deleteGroupMember",
    async (data) => {
      const res = await axiosInstance
        .delete(`/api/v1/payments/delete-payment-group-detail/${data?.pgdId}`)
        .then((res) => res.data);
      return res;
    }
  );
   
  export const deleteGroup = createAsyncThunk(
    "staffSettingSlice/deleteGroup",
    async (data) => {
      const res = await axiosInstance
        .delete(`/api/v1/payments/delete-payment-group/${data?.pgId}`)
        .then((res) => res.data);
      return res;
    }
  );

  export const deleteApprvConfig = createAsyncThunk(
    "staffSettingSlice/deleteApprvConfig",
    async (data) => {
      const res = await axiosInstance
        .delete(`/api/v1/approvals/delete-approval-conf/${data?.aprvId}`)
        .then((res) => res.data);
      return res;
    }
  );


  export const deleteUtility = createAsyncThunk(
    "staffSettingSlice/deleteUtility",
    async (data) => {
      const res = await axiosInstance
        .delete(`/api/v2/utility/deleteUtil/${data?.utilId}`)
        .then((res) => res.data);
      return res;
    }
  );

  export const deleteSettlement = createAsyncThunk(
    "staffSettingSlice/deleteSettlement",
    async (data) => {
      const res = await axiosInstance
        .delete(`/api/v1/wallet/delete-settlement/${data?.settlementId}`)
        .then((res) => res.data);
      return res;
    }
  );
 
  export const deleteNotification = createAsyncThunk(
    "staffSettingSlice/deleteNotification",
    async (data) => {
      const res = await axiosInstance
        .delete(`/api/v1/notification/${data?.notId}`)
        .then((res) => res.data);
      return res;
    }
  );



export const deleteSlice = createSlice({
    name: 'delete',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
 
        
        .addCase(deletePaybill.pending, (state) => {
          state.deleteloading = true;
        })
        .addCase(deletePaybill.fulfilled, (state,action) => {
          state.deleteloading = false;
        })
        .addCase(deletePaybill.rejected, (state) => {
          state.deleteloading = false;
        })

        .addCase(deleteTariff.pending, (state) => {
            state.deleteloading = true;
          })
          .addCase(deleteTariff.fulfilled, (state,action) => {
            state.deleteloading = false;
          })
          .addCase(deleteTariff.rejected, (state) => {
            state.deleteloading = false;
          })

          .addCase(deleteTariffNegotiated.pending, (state) => {
            state.deleteloading = true;
          })
          .addCase(deleteTariffNegotiated.fulfilled, (state,action) => {
            state.deleteloading = false;
          })
          .addCase(deleteTariffNegotiated.rejected, (state) => {
            state.deleteloading = false;
          })
            

          .addCase(deleteGroupMember.pending, (state) => {
            state.deleteloading = true;
          })
          .addCase(deleteGroupMember.fulfilled, (state,action) => {
            state.deleteloading = false;
          })
          .addCase(deleteGroupMember.rejected, (state) => {
            state.deleteloading = false;
          })

          .addCase(deleteGroup.pending, (state) => {
            state.deleteloading = true;
          })
          .addCase(deleteGroup.fulfilled, (state,action) => {
            state.deleteloading = false;
          })
          .addCase(deleteGroup.rejected, (state) => {
            state.deleteloading = false;
          })

          .addCase(deleteApprvConfig.pending, (state) => {
            state.deleteloading = true;
          })
          .addCase(deleteApprvConfig.fulfilled, (state,action) => {
            state.deleteloading = false;
          })
          .addCase(deleteApprvConfig.rejected, (state) => {
            state.deleteloading = false;
          })
            
          .addCase(deleteUtility.pending, (state) => {
            state.deleteloading = true;
          })
          .addCase(deleteUtility.fulfilled, (state,action) => {
            state.deleteloading = false;
          })
          .addCase(deleteUtility.rejected, (state) => {
            state.deleteloading = false;
          })

          .addCase(deleteSettlement.pending, (state) => {
            state.deleteloading = true;
          })
          .addCase(deleteSettlement.fulfilled, (state,action) => {
            state.deleteloading = false;
          })
          .addCase(deleteSettlement.rejected, (state) => {
            state.deleteloading = false;
          })
          

          .addCase(deleteNotification.pending, (state) => {
            state.deleteloading = true;
          })
          .addCase(deleteNotification.fulfilled, (state,action) => {
            state.deleteloading = false;
          })
          .addCase(deleteNotification.rejected, (state) => {
            state.deleteloading = false;
          })
          

          
        
  
    },
});

export default deleteSlice.reducer;
export const {} = deleteSlice.actions;
